import { Route, Routes, BrowserRouter } from "react-router-dom";
import { useContext, useEffect } from "react";

import { MainContext } from "./contexts/MainContext";
import { CommunicationProvider } from "./contexts/CommunicationContext";
import { WholeWrapper } from "./pages/landing/components";
import LandingPage from "./pages/landing/LandingPage";
import HomePage from "./pages/home/HomePage";
import Demo from "./pages/home apps/HomeDemo";
import Music from "./pages/music/Music";

import Store from "./pages/store/Store";
import CustomIframe from "./pages/iframe/CustomIframe";
import Spotify from "./pages/spotify/Spotify";
import Yummly from "./pages/yummly/Yummly";
import Washington from "./pages/washington/Washington";
// import EmptyStatePage from "./pages/dynamic-app-page/EmpyStatePage";
import DynamicAppPage from "./pages/dynamic-app-page/DynamicAppPage";
import NotFound from "./pages/not-found/NotFound";
import BelinsonMainPage from "./pages/belinson/BelinsonMainPage";
import BelinsonVideoPage from "./pages/belinson/videos-page/BelinsonVideoPage";
import ChosenVideo from "./pages/belinson/videos-page/ChosenVideo";
import BelinsonGamePage from "./pages/belinson/games-page/BelinsonGamePage";
import ChosenGame from "./pages/belinson/games-page/ChosenGame";
import JitsiPage from "./pages/jitsi/JitsiPage";
import Nurse from "./pages/nurse/Nurse";
import Cognishire from "./pages/cognishire/Cognishire";
import Webhook from "./pages/test-pages/Webhook";

function App() {
  const { landingOpen, setlandingOpen } = useContext(MainContext);

  useEffect(() => {
    (window.location.pathname.startsWith("/app") ||
      window.location.pathname.startsWith("/nurse") ||
      window.location.pathname.startsWith("/test")) &&
      setlandingOpen(false);
  }, [setlandingOpen]);

  return (
    <WholeWrapper className="App">
      {(landingOpen && <LandingPage onTouch={() => setlandingOpen(false)} />) || (
        <BrowserRouter>
          <Routes>
            <Route path={"/test/webhook"} exact element={<Webhook />} />
            <Route path={"/"} element={<HomePage />} />
            <Route path={"/store"} element={<Store />} />
            <Route path={"/demo"} element={<Demo />} />
            <Route path={"/music"} element={<Music />} />
            <Route path={"/iframe"} element={<CustomIframe />} />
            <Route path={"/spotify"} element={<Spotify />} />
            <Route path={"/yummly"} element={<Yummly />} />
            <Route path={"/washington"} element={<Washington />} />
            <Route path={"/nurse"} element={<Nurse />} />
            <Route path={"/app/jitsi"} exact element={<JitsiPage />} />

            <Route path={"/cognishine"} exact element={<Cognishire />} />

            {/* <Route path={"/app"} exact element={<EmptyStatePage />} /> */}

            <Route path={"/app/belinson"} element={<BelinsonMainPage />} />
            <Route path={"/app/belinson/videos"} element={<BelinsonVideoPage />} />
            <Route path={"/app/belinson/videos/:videoId"} element={<ChosenVideo />} />
            <Route path={"/app/belinson/games"} element={<BelinsonGamePage />} />
            <Route path={"/app/belinson/games/:gameId"} element={<ChosenGame />} />

            <Route
              path={"/app"}
              element={
                <CommunicationProvider>
                  <DynamicAppPage />
                </CommunicationProvider>
              }
            />

            <Route path={"*"} element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      )}
    </WholeWrapper>
  );
}

export default App;
